import en from './products.en';

const enConfig = { en };

export default enConfig;
